/* MARVI OCEAN - Ocean Encyclopedia search engine.
   Loaded last so it sees every fact file. Title > keywords > body. */
(function(){
'use strict';
var OJ = window.OJ = window.OJ || {};

/* 'many' and 'much' deliberately NOT stopwords: they carry real signal
   in "how many species" and "how much of the ocean". */
var STOP={the:1,and:1,for:1,are:1,how:1,what:1,why:1,can:1,does:1,did:1,you:1,know:1,
  that:1,with:1,from:1,they:1,this:1,there:1,have:1,its:1,was:1,were:1,about:1,
  really:1,actually:1,between:1};

function norm(s){ return (s||'').toLowerCase().replace(/[^a-z0-9 ]/g,' '); }
function hasWord(hay,w){ return new RegExp('\\b'+w).test(hay); }

OJ.search = function(query){
  var ws = norm(query).split(/\s+/).filter(function(w){ return w.length>2 && !STOP[w]; });
  if(!ws.length) return [];
  var out=[];
  for(var i=0;i<OJ.facts.length;i++){
    var f=OJ.facts[i];
    var Q=norm(f.q), K=norm(f.k), A=norm(f.a);
    var s=0, found=0;
    for(var j=0;j<ws.length;j++){
      var w=ws[j];
      if(hasWord(Q,w)) s+=10;
      else if(hasWord(K,w)) s+=6;
      else if(hasWord(A,w)) s+=2;
      else if(w.length>4 && (Q.indexOf(w.slice(0,-1))!==-1 || K.indexOf(w.slice(0,-1))!==-1)) s+=4;
      else if(w.length>4 && A.indexOf(w.slice(0,-1))!==-1) s+=1;
      else if(w.length>5 && (Q.indexOf(w.slice(0,w.length-2))!==-1 || K.indexOf(w.slice(0,w.length-2))!==-1)) s+=3;
      if(Q.indexOf(w)!==-1 || K.indexOf(w)!==-1 || A.indexOf(w)!==-1) found++;
    }
    if(s>0){ s += Math.round(found/ws.length*8); out.push({f:f,s:s}); }
  }
  out.sort(function(a,b){ return b.s-a.s; });
  return out.map(function(x){ return x.f; });
};

OJ.byTopic = function(t){ return OJ.facts.filter(function(f){ return f.t===t; }); };
})();
